// extracted by mini-css-extract-plugin
module.exports = {"inputEle":"PictureTaker_inputEle__3EWvE","button":"PictureTaker_button__1LP-w","inputEle--isFocus":"PictureTaker_inputEle--isFocus__2JM3t"};